<template>
  <div class="project-one__colorwheel">
    <span class="project-one__colorwheel-icon" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.project-one__colorwheel {
  display: flex;
  align-items: center;
  justify-content: center;

  .project-one__colorwheel-icon {
    --pdl-icon-mask-size: calc(var(--pdl-icon-size) * 0.8333334 / 4);
    display: inline-block;
    width: 83.33334%;
    height: 83.33334%;
    position: relative;
    top: 0;
    background: conic-gradient(
      #02b222,
      #00afd8 45deg,
      #28499c 90deg,
      #cf2b90 135deg,
      #cc0000 180deg,
      #f3a41e,
      #ffff00 300deg,
      #02b222
    );
    border-radius: 50%;
    mask: radial-gradient(var(--pdl-icon-mask-size), #0000 94%, #000);
  }
}
</style>
